import React from "react"
import styled from "styled-components"
import { fontSize, colors, fontWeight } from "buoy-theme"
import { HeadingThree, Paragraph } from "buoy-core"
import Arrow from "../images/arrow.svg"
import responsive from "../../../common/responsive"
import { generatePageUrl } from "../../../common/utils"
import { LazyResImage } from "../../../common/responsive"

const Container = styled.a`
  background-color: ${colors.white};
  overflow: hidden;
  margin: 20px 10px 20px;
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.1);
  transition: transform 0.5s;
  text-decoration: none;
  &:hover {
    transform: scale(1.05);
  }
  ${responsive("width", "300px", "300px", "50%", "280px")}
  ${responsive("flex-basis", "auto", "auto", "50%", "auto")}
  ${responsive("display", "block", "block", "none", "block")}
  
  &:nth-child(1) {
    ${responsive("margin-left", "0px", "0px", "0px", "10px")}
  } 

  &:nth-child(3) {
    ${responsive("margin-right", "0px", "0px", "0px", "10px")}
  } 

  &:nth-child(1),
  &:nth-child(2) {
    display: block;
  }
`

const InnerContainer = styled.div`
  padding: 16px 16px 20px 16px;
`

const Link = styled.div`
  ${fontSize("bodyMain")}
  font-weight: ${fontWeight.regular};
  color: ${colors.primary};
  display: flex;
  text-decoration: none;
  align-items: center;
`

const SymptomImage = styled.img`
  ${responsive("width", "300px", "300px", "100%", "100%")} height: auto;
`

const LinkArrow = styled.img`
  margin-left: 6px;
  height: 11px;
`

const Symptom = ({ headline, body, linkText, url, image }) => (
  <Container href={generatePageUrl(url)}>
    <LazyResImage src={image.src} alt={image.alt} width={300}>
      <SymptomImage />
    </LazyResImage>
    <InnerContainer>
      <HeadingThree alignLeft margin="0px 0px 4px">{headline}</HeadingThree>
      <Paragraph small margin="0 0 10px">
        {body}
      </Paragraph>
      <Link>
        {linkText} <LinkArrow src={Arrow} />
      </Link>
    </InnerContainer>
  </Container>
)

export { Symptom as default }



// WEBPACK FOOTER //
// ./src/components/Symptoms/components/Symptom.js